import { SENSECODE } from '@blade/common/constants/code';
export const MAP_ITEMS = [
    {
        name: 'CAM',
        path: '/screen-new/crowdInsightCam',
        code: SENSECODE.CROWD_CAM,
        cardId: SENSECODE.CROWD_CAM,
    },
    {
        name: 'CL',
        path: '/screen-new/crowdInsightCl',
        code: SENSECODE.CROWD_CL,
        cardId: SENSECODE.CROWD_CL,
    },
    {
        name: 'VA',
        path: '/screen-new/crowdInsightVa',
        code: SENSECODE.CROWD_VA,
        cardId: SENSECODE.CROWD_VA,
        snapShot: true,
    },
    {
        name: 'QUEUE',
        path: '/screen-new/queueInsight',
        code: SENSECODE.QUEUE_INSIGHT,
        cardId: SENSECODE.QUEUE_INSIGHT,
    },
    {
        name: 'ALERT',
        path: '/screen-new/alertMap',
        code: SENSECODE.ALERT_MAP,
        cardId: SENSECODE.ALERT_MAP,
    },
    {
        name: 'UV',
        path: '/screen-new/crowdInsightUv',
        code: SENSECODE.CROWD_UV,
        cardId: SENSECODE.CROWD_UV,
    },
    {
        name: 'PI',
        path: '/screen-new/parkingInsight',
        code: SENSECODE.PARKING_INSIGHT,
        cardId: SENSECODE.PARKING_INSIGHT,
    },
];
